export function getParentId(pathname: string): string {
  const pathnameArray = pathname.split('/');
  const pathNameLastItem = pathnameArray[pathnameArray.length - 1];
  return pathNameLastItem === 'welcome' ? 'root' : pathNameLastItem;
}

export function getIsInWelcomeScreen(pathname: string): boolean {
  const pathnameArray = pathname.split('/');
  return pathnameArray[pathnameArray.length - 1] === 'welcome';
}

export function getMode(role: string, welcomeScreenSelection?: string): string | undefined {
  const currentUserIsAdminOrPro = role === 'admin' || role === 'pro';
  return currentUserIsAdminOrPro ? welcomeScreenSelection : 'folder';
}

export function getHeadline(role: string, welcomeScreenSelection?: string): string {
  const mode = getMode(role, welcomeScreenSelection);
  return mode !== undefined ? `Create new ${mode}` : 'Create new';
}

export function validateTitleField(titleFieldValue: string, existingNames: string[] = []): string | false {
  const trimmed = titleFieldValue.trim();
  if (trimmed.length < 3) return 'Title must be at least 3 characters';
  if (titleFieldValue.length >= 50) return "Title can't be over 50 characters";
  if (existingNames.some((n) => n.trim().toLowerCase() === trimmed.toLowerCase())) {
    return 'An item with this name already exists';
  }
  return false;
}
